import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _set from "lodash/set";
import _cloneDeep from "lodash/cloneDeep";
import { getCurrentOrganizationId, getResponse, resolveRequire } from "../utils/utils";
import { queryPromptLocale } from "./api";
/**
 * 获取 ui 库 的多语言, 如果传了 language 和 promptKey, 那么使用传递的 多语言来覆盖 ui库多语言
 * @param {function()} loadFileIntl - 获取文件多语言的方法: () => Promise<any>
 * @param {string} language - 语言
 * @param {string} promptKey - 多语言编码前缀
 * @return {Promise<*>}
 */

export function getFileIntl() {
  return _getFileIntl.apply(this, arguments);
}
/**
 * 获取antd的国际化
 * hzero-ui/lib/locale-provider/{language}.js
 * @param {String} language
 */

function _getFileIntl() {
  _getFileIntl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var loadFileIntl,
      language,
      organizationId,
      promptKey,
      orgId,
      l,
      iRes,
      i,
      prefixLen,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            loadFileIntl = _args.length > 0 && _args[0] !== undefined ? _args[0] : function () {};
            language = _args.length > 1 ? _args[1] : undefined;
            organizationId = _args.length > 2 ? _args[2] : undefined;
            promptKey = _args.length > 3 ? _args[3] : undefined;
            orgId = getCurrentOrganizationId() || organizationId || 0;
            l = {};
            _context.prev = 6;
            _context.next = 9;
            return loadFileIntl();
          case 9:
            l = _context.sent;
            l = _cloneDeep(resolveRequire(l));
            _context.next = 16;
            break;
          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](6);
            l = {};
          case 16:
            iRes = {};
            if (!(language && promptKey && orgId !== undefined)) {
              _context.next = 24;
              break;
            }
            _context.next = 20;
            return queryPromptLocale(orgId, language, promptKey);
          case 20:
            iRes = _context.sent;
            i = getResponse(iRes) || {};
            prefixLen = promptKey.length + 1; // 覆盖 ui库 多语言

            Object.keys(i).forEach(function (intlCode) {
              _set(l, intlCode.substr(prefixLen), i[intlCode]);
            });
          case 24:
            return _context.abrupt("return", l);
          case 25:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6, 13]]);
  }));
  return _getFileIntl.apply(this, arguments);
}
export function getHzeroUILocale(_x, _x2) {
  return _getHzeroUILocale.apply(this, arguments);
}
/**
 * 获取c7n的国际化
 * choerodon-ui/es/locale-provider/{language}.js
 * @param {String} language
 */

function _getHzeroUILocale() {
  _getHzeroUILocale = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(language, organizationId) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", getFileIntl(function () {
              return import("hzero-ui/es/locale-provider/".concat(language.replace('-', '_'), ".js"));
            }, language, organizationId, 'hzero.hzeroUI'));
          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getHzeroUILocale.apply(this, arguments);
}
export function getC7nLocale(_x3, _x4) {
  return _getC7nLocale.apply(this, arguments);
}
/**
 * 获取c7n-pro的国际化
 * choerodon-ui/pro/lib/locale-context/{language}.js
 * @param {String} language
 */

function _getC7nLocale() {
  _getC7nLocale = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(language, organizationId) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", getFileIntl(function () {
              return import("choerodon-ui/es/locale-provider/".concat(language.replace('-', '_'), ".js"));
            }, language, organizationId, 'hzero.c7nUI'));
          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getC7nLocale.apply(this, arguments);
}
export function getC7nProLocale(_x5, _x6) {
  return _getC7nProLocale.apply(this, arguments);
}
function _getC7nProLocale() {
  _getC7nProLocale = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(language, organizationId) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", getFileIntl(function () {
              return import("choerodon-ui/pro/lib/locale-context/".concat(language.replace('-', '_'), ".js"));
            }, language, organizationId, 'hzero.c7nProUI'));
          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getC7nProLocale.apply(this, arguments);
}